module.exports = __webpack_public_path__ + "static/media/bubble - Copy.72dffb62.svg";